import { useState } from "react";
import { useDispatch } from "react-redux";
import { store } from 'Store';
import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { setGlobalErrorStatus, setGlobalWarningStatus } from 'Components/StatusHandling'
import {ERROR_MESSAGES, STATUSES, WARNING_MESSAGES} from "Utils/constants";
import { Col } from 'react-bootstrap';
import { TextButton } from 'Components/Button';
import { ICONS } from "Utils/icons";

const PSEProdBatchCompleted = () => {

  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;
  const dispatch = useDispatch();

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }

  /** Start of completedPSEProdBatch */
  const completedPSEProdBatchHeader = "Processed Production Data Submissions";
  const completedPSEProdBatchSearchFieldText = "Search by ID";

  const [completedPSEProdBatchSortColumn, setCompletedPSEProdBatchSortColumn] = useState({
    sortField: "submitDate",
    sortDirection: "desc"
  });

  // Flag: trigger api to reload data
  const [reloadCompletedPSEProdBatch, setReloadCompletedPSEProdBatch] = useState(false);
  const [selected, setSelected] = useState(
    {
      allSelected: false,
      selectedCount: 0,
      selectedRows: []
    }
  );

  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];

    const nameState = function ({ rowName }) {
      //console.log("printout rowName", rowName);
      return { id: rowName.id };
    }
    listColumns.push(Datatable_Column({ name: "PSO ID", columnName: "submitPsoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Batch ID", columnName: "id", selectedRows: selectedList, sortable: true, sortFieldNum: 0, isLink: true, linkData: { title: "", pathname: "/eventDataSubmission/displayBatchDetail", text: null, state: nameState }, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Setting", columnName: "cfSetting", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "No of Files", columnName: "fileCount", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Accepted", columnName: "totalAccepted", selectedRows: selectedList, sortable: true, sortFieldNum: 3, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Rejected", columnName: "rejected", selectedRows: selectedList, sortable: true, sortFieldNum: 4, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Submission Date", columnName: "submitDate", selectedRows: selectedList, sortable: true, sortFieldNum: 5, formatFunction: handleDateFormat, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Report", columnName: "viewReport", selectedRows: selectedList, sortable: false, sortFieldNum: 6, isButton: true, buttonData: { title: "", action: handleFileDownload, text: "Download", icon: ICONS.download }, sortingInfo: sortingInfo, title: 'Download Report to View' }));

    return listColumns;
  }

  const handleFileDownload = async (row/*, batchId, fileName*/) => {
    const res = await submitDownload(row.id, row.cfSetting);
    if (res) {
      // get filename from the res content-disposition
      const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');

      let url = window.URL.createObjectURL(res.data);
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    }
  }

  const submitDownload = async (batchId, cfSetting) => {
    const call = {
      batchId: batchId,
      isTestSubmission: "N",
      settingName: cfSetting
    }

    const url = '/api/report/batchDetail';

    return httpDownload.post(url, call, {
      responseType: "blob",
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch(async (error) => {
      //console.log("error handleFileDownload()", error);
      let parsedData = null;
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          parsedData = JSON.parse(text);
        } catch (_) {}
      }
      const payload = { err: error, data: parsedData ?? error.response };
      payload.data?.status === 413 ?
        setGlobalWarningStatus({
          dispatch,
          popupData: {
            visible: true,
            title: WARNING_MESSAGES.WARNING.title,
            msg: getPopupWarningMessage(payload?.data?.globalErrorMessageList?.[0] ?? WARNING_MESSAGES.WARNING.message),
            showContactHelp: false
          },
          redirect: { redirect: false, redirectFirst: false, path: "", data: {} },
          error
        }) :
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        }
      );
    });
  }

  // Delete completed PSE Production Batch
  const deleteCompletedPSEProdBatch = (batchList) => {
    //console.log("print out deleteCompletedPSEProdBatch", batchList);
    /**TODO!!!: 
     * 1. call api to delete batches 
     * 2. reload the data 
     * */
    setReloadCompletedPSEProdBatch(true);
  }

  /** End of inProgressPSEProdBatch */

  const getData = async (filter) => {
    var call = {
      paginationRequest: filter,
      isTestSubmission: "N"
    }
    var url = '/api/cda/completedBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": token
      }
    });
  }

  const getDeleteBatchesText = () => {

    if (selected.selectedCount > 1) {
      return "Delete Selected Batch(es)";
    }
    else {
      return "Delete Selected Batch";
    }
  }
  
  const getPopupWarningMessage = (payload) => {
    return (
      <>
        <p>{payload} Please contact PSOPPC help desk at <a className={"supportEmail"} href={'mailto:support@psoppc.org'}>support@psoppc.org</a> to generate this report.</p>
      </>
    );
  }

  return (
    <>
      <DatatableBase
        tableClassName="cdaProdCompletedTable"
        reload={reloadCompletedPSEProdBatch}
        setReload={setReloadCompletedPSEProdBatch}
        getData={getData}
        getListCols={getListCols}
        setSelected={setSelected}
        hasSelectableRows={false}
        searchFieldText={completedPSEProdBatchSearchFieldText}
        datatableHeader={completedPSEProdBatchHeader}
        datatableDescription={null}
        sortingColumn={completedPSEProdBatchSortColumn.sortField}
        sortingOrder={completedPSEProdBatchSortColumn.sortDirection}
      >
        {
          // <Col className="d-flex justify-content-end ">
          //   <TextButton className="ms-auto" onClick={deleteCompletedPSEProdBatch} variant="normal" content={getDeleteBatchesText()} disabled={selected.selectedCount < 1 ? true : false} />
          // </Col>
        }
      </DatatableBase>
    </>
  )
}

export default PSEProdBatchCompleted;